export default __webpack_public_path__ + "static/media/girl1.dd222364.svg";